var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "quartz-core": "static-1.6466"
    },
    "depPathPrefixes": {
      "quartz-core": "/quartz-core/static-1.6466"
    },
    "bundlingPackage": "documents-public-ui",
    "bundlingPackageVersion": "static-1.34960",
    "project": "quartz-core",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};